// extracted by mini-css-extract-plugin
module.exports = {"social":"xceP93","socialButton":"_7g3GN7","icon":"rsosat"};